module.exports = __webpack_public_path__ + "static/media/person.f0ce3ca7.svg";